<template>
  <div class="booking-confirmation-generic-error">
    <div class="container-fluid">
      <div class="row no-gutters">
        <div class="col-12 col-lg-8 offset-lg-2">
          <div class="booking-confirmation-timeout__interaction">
            <CiInfoBox :type="'warning'">
              <h3 class="booking__headline">
                {{ $t('pages.bookingConfirmationGenericError.infoBox.title') }}
              </h3>
              <p
                v-html="
                  $t('pages.bookingConfirmationGenericError.infoBox.copy')
                "
              ></p>
              <CiButton
                class="navigation__button button--primary"
                @click="startOver()"
              >
                <span>{{
                  $t(
                    'pages.bookingConfirmationTimeout.refundSuccess.infoBox.button'
                  )
                }}</span>
                <iconArrowWhite class="icon icon--animated"></iconArrowWhite>
              </CiButton>
            </CiInfoBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { CiButton, CiInfoBox } from '@/components'

import iconArrowWhite from '@/assets/icons/arrow-white.svg'

export default {
  name: 'BookingConfirmationGenericError',
  components: {
    CiButton,
    CiInfoBox,
    iconArrowWhite,
  },
  created() {
    this.setLoader(false)
  },
  methods: {
    ...mapActions('application', {
      setLoader: 'setLoader',
      resetStepStatus: 'resetStepStatus',
    }),

    ...mapActions('booking', {
      resetBookingState: 'resetState',
    }),

    startOver() {
      this.$router.push({
        name: 'Step',
        params: { ...this.$route.params, step: 1 },
      })

      /* reset booking state */
      this.resetBookingState()

      /* reset step status */
      this.resetStepStatus()
    },
  },
}
</script>

<style lang="scss" scoped>
.booking-confirmation-generic-error {
  min-height: 100vh;

  @include media-breakpoint-up(lg) {
    > .container-fluid {
      padding: 0;
    }

    > .container-fluid,
    > .container-fluid > .row {
      min-height: 100vh;
    }
  }
}
</style>
